


import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="md:px-20 isolate px-6 lg:px-8 flex flex-1 flex-col max-w-4xl mb-20">
      <h1 className="tx1 text-center pt-10 md:pt-20">{t('aboutPage.title')}</h1>

      <section className="mb-10">
        <h2 className="tx2 mb-10 highlight">{t('aboutPage.subtitle')}</h2>
        <div className="tm1 text-justify">
          {t('aboutPage.intro')}
        </div>
      </section>

      <section className="mb-10">
        <div className="tm1 text-justify">
          {t('aboutPage.bio')}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="tx2 mb-4">{t('aboutPage.privateTitle')}</h2>
        <div className="tm1 text-justify">
          {t('aboutPage.private')}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="tx2 mb-4 highlight">{t('aboutPage.contactTitle')}</h2>
        <div className="tm1 text-justify">
          {t('aboutPage.contact')} 
          <span className="highlight"> {t('aboutPage.contactHighlight')}</span>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="tx2 mb-4">{t('aboutPage.techTitle')}</h2>
        <div className="tm1 text-justify">
          {t('aboutPage.tech')}
        </div>
        <div className="flex justify-center mt-8">
          <a
            href="https://github.com/pawelmat142"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-md btn-primary px-4 py-2 font-semibold text-white shadow-sm w-fit hover:bg-gray-800 transition-colors"
          >
            <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" className="inline-block">
              <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.207 11.387.6.113.793-.262.793-.583 0-.288-.012-1.243-.017-2.252-3.338.726-4.042-1.415-4.042-1.415-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.729.083-.729 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.418-1.305.762-1.606-2.665-.304-5.466-1.332-5.466-5.931 0-1.31.469-2.381 1.236-3.221-.124-.303-.535-1.523.117-3.176 0 0 1.008-.322 3.3 1.23a11.5 11.5 0 013.003-.404c1.02.005 2.047.138 3.003.404 2.291-1.553 3.297-1.23 3.297-1.23.653 1.653.242 2.873.119 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.804 5.625-5.475 5.921.43.371.823 1.102.823 2.222 0 1.606-.015 2.898-.015 3.293 0 .324.192.699.8.581C20.565 21.796 24 17.297 24 12c0-6.63-5.37-12-12-12z" />
            </svg>
            <span>{t('aboutPage.github')}</span>
          </a>
        </div>
      </section>

    </div>
  );
}